import { Component, forwardRef, Input } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { TenantFilterDto } from '@artemis-software/wr-api';
import { AbstractFormControl } from '@shared/form-controls/abstract-form-control';

@Component({
  standalone: false,
  selector: 'wr-facility-element-select',
  templateUrl: './facility-element-select.component.html',
  styleUrl: './facility-element-select.component.scss',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => FacilityElementSelectComponent),
      multi: true,
    },
  ],
})
export class FacilityElementSelectComponent extends AbstractFormControl<TenantFilterDto.FacilityElementEnum | null> {
  readonly facilityElements = Object.values(TenantFilterDto.FacilityElementEnum);

  @Input()
  showEmptyOption = false;
}
